import { UNEXPECTED_ERROR_MESSAGE } from '@/const/shared';

export class ResponseError extends Error {
  constructor(errorText = UNEXPECTED_ERROR_MESSAGE) {
    super(errorText);
    this.name = 'ResponseError';
  }
}
